import {
  GENERATEWALLETTRANSACTIONREPORTFILE_SUCCESS,
  GENERATEWALLETTRANSACTIONREPORTFILE_FAILED,
  RESET_GENERATEWALLETTRANSACTIONREPORTFILE,
  LOADING_GENERATEWALLETTRANSACTIONREPORTFILE,
  NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GENERATEWALLETTRANSACTIONREPORTFILE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GENERATEWALLETTRANSACTIONREPORTFILE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GENERATEWALLETTRANSACTIONREPORTFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GENERATEWALLETTRANSACTIONREPORTFILE:
      return (state = initialState);
    default:
      return state;
  }
};
